export class InfoViewEvents {
	public static readonly WIN_UPDATED: string = 'InfoViewEvents::WIN_UPDATED';
	public static readonly BET_UPDATED: string = 'InfoViewEvents::BET_UPDATED';
	public static readonly BALANCE_UPDATED: string = 'InfoViewEvents::BALANCE_UPDATED';
	public static readonly TIME_UPDATED: string = 'InfoViewEvents::TIME_UPDATED';
	public static readonly TEXT_INITIALIZED: string = 'InfoViewEvents::TEXT_INITIALIZED';
	public static readonly TOGGLE_ALL_SOUND_OFF: string = 'InfoViewEvents::TOGGLE_ALL_SOUND_OFF';
	public static readonly TOGGLE_ALL_SOUND_ON: string = 'InfoViewEvents::TOGGLE_ALL_SOUND_ON';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/InfoViewEvents.ts